import { Box, Button, Typography, Dialog, DialogContent, DialogActions, Tooltip, Breadcrumbs, useMediaQuery, useTheme, Grid } from '@mui/material';
import React, { useEffect, useState, forwardRef } from 'react';
import CustomSearchInput from '../common/CustomSearchInput';
import CustomSelect from '../common/customSelectInput';
import { HttpRequest } from '../HttpRequest';
import imagePlaceholder from "../../images/img-holder-icn.svg";
import editIcon from '../../images/edit-icn.svg';
import deleteIcon from '../../images/delete-icn.svg';
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import CurrencyFormatter from '../common/currencyFormatter';
import { ContentCopy } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { setMaxNoOfItems, setProductIsPackage, setAdditionalImages, setAdditionalServicesData, setFeaturedImage, setPricingData, setProductCategory, setProductDescription, setProductName, setProductTypeData, setTagsData, setVariations, setThumbnailImage } from '../../features/productSlice';
import { SuccessAlert } from '../common/snackbar/success';
import { ErrorAlert } from '../common/snackbar/error';
import secureLocalStorage from 'react-secure-storage';
import DeImg from '../../images/crosImg.svg';
import WarningImg from '../../images/warning-remove-icn.svg';
import Slide from '@mui/material/Slide';
import ReusableModal from '../common/ReusableModal';
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const NoProductsOverlay = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', gap: 1.5, py: 6 }}>
    <Box sx={{ width: 60, height: 60, borderRadius: '50%', backgroundColor: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Typography sx={{ fontSize: '28px' }}>📦</Typography>
    </Box>
    <Typography sx={{ color: '#032541', fontWeight: 600, fontSize: '15px', fontFamily: 'Poppins' }}>No products found</Typography>
    <Typography sx={{ color: '#707070', fontSize: '13px', fontFamily: 'Poppins' }}>Try adjusting your search or filter criteria</Typography>
  </Box>
);

const status = [
  { id: 1, label: 'All', value: 'all' },
  { id: 2, label: 'In Stock', value: 'in_stock' },
  { id: 3, label: 'Running Low', value: 'running_low' },
  { id: 4, label: 'Preorder', value: 'preorder' },
  { id: 5, label: 'Out of Stock', value: 'out_of_stock' }
];

const renderCategoryColumns = (row) => {
  return (
    <Box style={{ cursor: 'pointer', color: "#707070", fontSize: "15px", fontWeight: "500" }}>
      {row.productCategory}
    </Box>
  );
};

const Products = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const [search, setSearch] = useState('');
  const [categories, setCategories] = useState([]);
  const [categoriesData, setCategoriesData] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [searchSubCategory, setSearchSubCategory] = useState('');
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const handleOpenDeleteCategory = () => { setOpenDeleteCategory(true); };
  const handleCloseDeleteCategory = () => { setOpenDeleteCategory(false); };
  const navigate = useNavigate();
  const [dataGridPageSize, setPageSize] = useState(10);
  const [pageState, setPageState] = useState({ isLoading: false, data: [], total: 0, page: 1, pageSize: dataGridPageSize });
  const businessNumber = secureLocalStorage.getItem("businessId");
  const [searchCategory, setSearchCategory] = useState('');
  const dispatch = useDispatch();
  const [errorShow, setErrorShow] = useState({ state: false, message: "" })
  const [successShow, setSuccessShow] = useState({ state: false, message: "" })
  const [open, setOpen] = useState(false);
  const [triggerEffect, setTriggerEffect] = useState(false);

  const handleClose = () => setOpen(false);

  const RenderCellAction = (params) => {
    const [productId , setProductId] = useState(null)
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false)

    const handleOpenDeleteDialog = (id) => {
      setProductId(id)
      setOpenDeleteDialog(true)
    }

    const handleCloseDeleteDialog = () => {
      setOpenDeleteDialog(false)
    }

    function deactivateProducts(id) {
      try {
        setPageState((old) => ({ ...old, isLoading: true }));
    
        HttpRequest({
          method: "PUT",
          url: `/api/updateProduct`,
          body: {
            productState: "Deactivation",
            productId: [id],
          },
        }).then((data) => {
          if (data.status === 202) {
            setSuccessShow({ state: true, message: "Product has been deactivated" });
            
            setTimeout(() => {
              getCategories();
              getProducts();
              setPageState((old) => ({ ...old, isLoading: false }));
              window.location.reload();
            }, 18000);
          } else {
            setErrorShow({ state: true, message: data.response.message });
            setTimeout(() => {
              getCategories();
              getProducts();
              setPageState((old) => ({ ...old, isLoading: false }));
              window.location.reload();
            }, 18000);
          }
        }).catch((error) => {
          console.error("Error in product deactivation:", error);
          setPageState((old) => ({ ...old, isLoading: false })); 
        });
      } catch (error) {
        console.error("Unexpected error:", error);
        setPageState((old) => ({ ...old, isLoading: false }));
      }
    }
    
    return (
      <Box style={{ color: "#032541", fontSize: isMobile ? "14px" : "17px", fontWeight: "700", display: 'flex' }}>
        <Tooltip title="Edit">
        <Button onClick={(event) => { event.stopPropagation(); clearExistingProductDetails(); fetchProductDetails(params?.row?.productId); navigate(`/zed_ecommerce/products/${params?.row?.productId}/edit`); }} style={{ textDecoration: 'none', minWidth: 'auto', padding: isMobile ? '4px' : '8px' }}>
          <img src={editIcon} alt='' style={{ width: isMobile ? 16 : 20, height: isMobile ? 16 : 20, margin: isMobile ? '0 8px 0 0' : '0 21px 0 0', objectFit: 'contain' }} />
        </Button>
        </Tooltip>
        <Tooltip title="Deactivate">
        <Button onClick={(event) => {event.stopPropagation();handleOpenDeleteDialog(params?.row?._id); }} style={{ minWidth: 'auto', padding: isMobile ? '4px' : '8px' }}>
          <img src={DeImg} style={{ marginTop: isMobile ? '2px' : '5px', objectFit: 'contain', width: isMobile ? 16 : 20, height: isMobile ? 16 : 20 }} alt='deactivate' />
        </Button>
        </Tooltip>
        <div>
        <ReusableModal open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", pt: 4, px: 3,}}>
            <Box sx={{ mb: 2 }}>
              <img src={WarningImg} alt="warning" width={70} height={70} />
            </Box>
            <Typography sx={{ color: "#032541", fontWeight: 600, fontSize: { xs: "16px", sm: "18px" }, mb: 1.5, textAlign: "center", fontFamily: "Poppins", }}>
              Deactivate Product
            </Typography>
            <Typography sx={{ color: "#707070", fontFamily: "Poppins", fontSize: { xs: "12px", sm: "14px" }, textAlign: "center", mb: 3,}}>
              Selected product will be deactivated for your business.
              <br />
              You can restore it later.
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
              <Button sx={{ height: "45px", width: "125px", borderRadius: "4px", backgroundColor: "#dc3545", border: "1px solid #dc3545", color: "#fff", fontWeight: 600, fontSize: "14px", fontFamily: "Poppins", textTransform: "none", "&:hover": { backgroundColor: "#c82333" },}} onClick={() => { deactivateProducts(productId); handleCloseDeleteDialog();}}>
                Deactivate
              </Button>
            </Box>
          </Box>
        </ReusableModal>
        </div>
      </Box>
    )
  }

  const columns = [
    {
      field: 'index', headerName: 'Index', flex: isMobile ? 0.5 : 0,
      renderHeader: () => (
        <Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> No. </Box>
      ),
      renderCell: (params) => (
        <Box sx={{ color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "500" }}>
          {params?.row?.index}
        </Box>
      )
    },
    {
      field: 'productName', headerName: 'Product Name', flex: isMobile ? 2 : 2,
      renderHeader: () => (
        <Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Product Name </Box>
      ),
      renderCell: (params) => (
        <Box
          sx={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "500", width: '100%', display: 'flex', alignItems: 'center', gap: 1, py: isMobile ? 1 : 2 }}
          onClick={() => navigate(`/zed_ecommerce/products/${params?.row?.productId}/edit`)}
        >
          <Box component={'img'} src={params.row.featuredImage || imagePlaceholder} sx={{ width: isMobile ? '25px' : '30px', height: isMobile ? '25px' : '30px', objectFit: 'contain' }} />
          <Typography sx={{ fontSize: isMobile ? "11px" : "14px" }}>{params.row.productName}</Typography>
        </Box>
      )
    },
    {
      field: 'price', headerName: 'Price', flex: isMobile ? 0.8 : 0,
      renderHeader: () => (
        <Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Price </Box>
      ),
      renderCell: (params) => (
        <Box
          sx={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "500" }}
          onClick={() => navigate(`/zed_ecommerce/products/${params?.row?.productId}/edit`)}
        >
          {CurrencyFormatter(params?.row?.discountedPrice ?? params.row.productPrice, 'KES')}
        </Box>
      )
    },
    {
      field: 'categories', headerName: 'Categories', flex: isMobile ? 1.2 : 1,
      renderHeader: () => (
        <Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Categories </Box>
      ),
      renderCell: (params) => (
        <Box sx={{ cursor: 'pointer' }} onClick={() => navigate(`/zed_ecommerce/products/${params?.row?.productId}/edit`)}>
          {renderCategoryColumns(params?.row)}
        </Box>
      )
    },
    {
      field: 'tags', headerName: 'Tags', flex: isMobile ? 1.5 : 2,
      renderHeader: () => (
        <Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Tags </Box>
      ),
      renderCell: (params) => (
        <Box sx={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "500" }} onClick={() => navigate(`/zed_ecommerce/products/${params.row?.productId}/edit`)}>
          {params.row.tags.map(tag => tag.tagName).join(', ')}
        </Box>
      )
    },
    {
      field: 'actions', headerName: 'Actions', flex: isMobile ? 1 : 1,
      renderHeader: () => (
        <Box sx={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700", py: isMobile ? 1 : 2 }}>
          Actions
        </Box>
      ),
      renderCell: RenderCellAction
    }
  ];

  const clearExistingProductDetails = () => {
    dispatch(setProductTypeData(''));
    dispatch(setProductCategory(''));
    dispatch(setProductName(''));
    dispatch(setVariations([]));
    dispatch(setTagsData([]));
    dispatch(setProductDescription())
    dispatch(setAdditionalServicesData([]));
    dispatch(setFeaturedImage(''));
    dispatch(setAdditionalImages([]));
    dispatch(setProductIsPackage(false));
    dispatch(setMaxNoOfItems(0));
  }

  const handleCopy = (productId) => {
    fetchProductDetails(productId);
  }

  const fetchProductDetails = (productId) => {
    const businessNumber = secureLocalStorage.getItem("businessId");
    HttpRequest({
      method: "GET",
      url: `/api/v1/ecommerce/get_product/${productId}?businessNumber=${businessNumber}`,
    }).then((data) => {
      if (data.status === 200) {
        const productDetails = data?.response?.data;
        console.log(productDetails , 'productDetails @@')
        dispatch(setProductTypeData(productDetails?.productType));
        dispatch(setProductName(productDetails?.productName));
        dispatch(setProductCategory(productDetails?.productCategory));
        dispatch(setProductDescription(productDetails?.productDescription));
        dispatch(setVariations(productDetails?.variations));
        dispatch(setFeaturedImage(productDetails?.featuredImage));
        dispatch(setThumbnailImage(productDetails?.thumbnail));
        dispatch(setAdditionalImages(productDetails?.additionalImages));
        dispatch(setPricingData(productDetails?.pricing));
        dispatch(setTagsData(productDetails?.tags));
        dispatch(setAdditionalServicesData(productDetails?.additionalServices));
        //navigate('/zed_ecommerce/addProducts');
      } else {
        setErrorShow({ state: true, message: 'Error duplicating the product' });
      }
    }).catch((error) => {
    });
  };

  const handleCategoryChange = (e) => {
    const val = e.target.value;
    setSearchCategory(val);
    setSearchSubCategory('');
    const cat = categoriesData.find(c => c.value === val);
    if (cat && cat.subCategories?.length > 0) {
      setSubCategories(cat.subCategories.map(sc => ({ label: sc.categoryName, value: sc.categoryName })));
    } else {
      setSubCategories([]);
    }
  };

  const getCategories = () => {
    HttpRequest({
      method: 'GET',
      url: `/api/v1/ecommerce/get_categories?businessNumber=${businessNumber}`
    }).then((data) => {
      const raw = data.response.data.map((item) => ({
        label: item.categoryName,
        value: item.categoryName,
        subCategories: item.subCategories || [],
      }));
      setCategoriesData(raw);
      setCategories(raw.map(({ label, value }) => ({ label, value })));
    }).catch((error) => {
    });
  };

  const getCategoryFilter = () => {
    if (searchSubCategory) return `categoryName=${encodeURIComponent(searchSubCategory.trim())}`;
    if (searchCategory && subCategories.length > 0) {
      return subCategories.map(sc => `categoryName=${encodeURIComponent(sc.value.trim())}`).join('&');
    }
    return `categoryName=${encodeURIComponent(searchCategory.trim())}`;
  };

  const getProducts = () => {
    setPageState((old) => ({ ...old, isLoading: true }));
    HttpRequest({
      method: 'GET',
      url: `/api/v1/ecommerce/get_products_pricing?businessNumber=${businessNumber}&page=${pageState.page}&limit=${dataGridPageSize}&search=${search.trim()}&${getCategoryFilter()}`
    }).then((data) => {
      if (data.status === 200) {
        setPageState((old) => ({
          ...old,
          isLoading: false,
          total: data.response.count,
          data: data.response.data.map((row, index) => ({
            ...row,
            index: index + 1 + (pageState.page - 1) * dataGridPageSize
          }))
        }));
      }
    }).catch((error) => {
      setPageState((old) => ({ ...old, isLoading: false }));
    });
  };

  useEffect(() => {
    getCategories();
    getProducts();
  }, [dataGridPageSize, pageState.page, businessNumber, search, searchCategory, searchSubCategory, subCategories, triggerEffect]);

  const breadcrumbs = [
      <Typography key="X" sx={{ color: "#707070", fontSize: "0.875rem", ml: isMobile ? 3 : 3 }}>
          Dashboard
      </Typography>,
      <Typography key="X" sx={{ color: "#707070", fontSize: "0.875rem" }}>
          Inventory
      </Typography>,
      <Typography key={"add"} sx={{ color: "#dc3545", fontSize: "0.875rem" }}>
          Products
      </Typography>
    ];

  return (
    <Box sx={{ mt: { xs: "15%", sm: "4%" }, pr: { xs: 2, sm: "3.5%" }, width: { xs: "100vw", sm: "calc(100vw - 360px)" }, maxWidth: "100%", overflowX: "hidden", boxSizing: "border-box", px: { xs: 2, sm: 0 }, ml: { xs: -3, sm: 0 } }}>
        <SuccessAlert vertical="top" horizontal="right" onClose={() => setSuccessShow({ ...successShow, state: false })} open={successShow.state} message={successShow.message} />
        <ErrorAlert vertical="top" horizontal="right" onClose={() => setErrorShow({ ...errorShow, state: false })} open={errorShow.state} message={errorShow.message} />
      
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: { xs: "flex-start", sm: "center" }, flexDirection: { xs: "column", sm: "row" }, gap: { xs: 2, sm: 0 } }}>
        <Box sx={{ flexDirection: "column", flex: 1 }}>
          <Typography variant='h4' sx={{ color: "#032541", fontSize: { xs: "18px", sm: "28px" }, fontStyle: "normal", fontWeight: "600", mb: 1.5 }}>
            Products
          </Typography>
          <Grid item sx={{ mt: 1, mb: { xs: 1, sm: 1 }, ml: { xs: -3, sm: -3 } }}>
            <Breadcrumbs style={{ fontFamily: 'Poppins', fontSize: { xs: "11px", sm: "13px" } }} separator={<FiberManualRecordIcon style={{ fontSize: "0.625rem", fontFamily: 'Poppins', color: "#e1e5e8" }} />} aria-label="breadcrumb">
              {breadcrumbs}
            </Breadcrumbs>
          </Grid>
          <Typography variant='h4' sx={{ color: "#707070", fontSize: { xs: "12px", sm: "14px" }, fontStyle: "normal", fontWeight: "normal" }}>
            View and manage your product categories.
          </Typography>
        </Box>
        <Box sx={{ width: { xs: '100%', sm: 'auto' }, mt: { xs: 2, sm: 0 } }}>
          <Button variant="contained" sx={{ backgroundColor: "#032541", color: "#fff", textTransform: "none", borderRadius: "5px", padding: "10.4px 18px 9.6px 19px", width: { xs: '100%', sm: "125px" }, height: "40px", "&:hover": { backgroundColor: "#032541", color: "#fff" } }} onClick={() => { clearExistingProductDetails(); navigate('/zed_ecommerce/addProducts') }}>
            Add Product
          </Button>
        </Box>
      </Box>
      
      <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: { xs: "column", sm: "row" }, gap: { xs: 2, sm: 2 }, mt: 2 }}>
        <Box sx={{ width: { xs: '100%', sm: 'auto' }, mt: { xs: 0, sm: -4 } }}>
          <CustomSearchInput placeholder={"Search ...."} name="search" value={search} onInput={(e) => setSearch(e.target.value)} sx={{ width: { xs: '100%', sm: 'auto' } }} />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: 'auto' } }}>
          <CustomSelect value={searchCategory} options={categories} placeholder={"All Categories"} sm={"xl"} style={{ width: '250px' }} onChange={handleCategoryChange} />
        </Box>
        {subCategories.length > 0 && (
          <Box sx={{ width: { xs: '100%', sm: 'auto' } }}>
            <CustomSelect value={searchSubCategory} options={subCategories} placeholder={"All Subcategories"} sm={"xl"} style={{ width: '250px' }} onChange={(e) => setSearchSubCategory(e.target.value)} />
          </Box>
        )}
      </Box>
      
      <Box sx={{ width: '100%', overflowX: 'auto', mt: 2 }}>
        <Box sx={{ minWidth: { xs: 800, sm: '100%' } }}>
          <DataGrid
            slots={{ noRowsOverlay: NoProductsOverlay }}
            sx={{ minHeight: '500px', height: 'auto', width: 'auto', fontFamily: 'Poppins', fontSize: isMobile ? '10px' : '12px', color: '#272d3d', boxShadow: 0, border: 0, '& .MuiDataGrid-cell': { fontSize: isMobile ? '10px' : '12px',}, '--DataGrid-overlayHeight': '300px' }}
            rowCount={pageState.total}
            pagination
            loading={pageState.isLoading}
            page={pageState.page - 1}
            pageSizeOptions={[1, 10, 20, 50, 100]}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: dataGridPageSize,
                  page: pageState.page - 1,
                },
              },
            }}
            pageSize={dataGridPageSize}
            onPaginationModelChange={(data) => {
              const { pageSize, page } = data;
              setPageState((old) => ({ ...old, page: page + 1, pageSize: pageSize }));
              setPageSize(pageSize);
            }}
            paginationMode="server"
            columns={columns}
            rows={pageState.data}
            getRowId={(row) => row._id}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Products;